import {h, Component} from 'preact'
import Card from './card'

export default class CardList extends Component {
  render ({cards, activeCategory}) {
    let items = cards
      .filter((card) => !activeCategory || card.categories.indexOf(activeCategory) >= 0)
      .map((card, i) => <Card key={i} {...card} />)

    if (!items.length) {
      items = <p class="text-center">Es wurden keine Ergebnisse gefunden.</p>
    }

    return (
      <div class="card-list">
        {items}
      </div>
    )
  }
}
